import React from 'react';
import { Alert, Box, Button, Chip, CircularProgress } from '@mui/material';

export default function PerformanceRatioInfo({ estado }) {
  return (
    <Box sx={{ my: 1 }}>
      {estado.carregando && <CircularProgress size={18} aria-label="Carregando PR" />}
      {estado.erro && <Alert severity="error" action={<Button color="inherit" onClick={estado.recarregar}>Tentar novamente</Button>}>{estado.erro}</Alert>}
      {estado.pronto && <Chip size="small" label={`PR: ${(estado.pr * 100).toLocaleString('pt-BR', { maximumFractionDigits: 2 })}%${estado.origem === 'salvo' ? ' (salvo)' : ''}`} />}
      {estado.aviso && <Alert severity="warning" sx={{ mt: 1 }}>{estado.aviso}</Alert>}
    </Box>
  );
}
